import { createFileRoute } from "@tanstack/react-router";
import { BrandReviewPage } from "@/features/brand-review";

export const Route = createFileRoute("/_authenticated/org/brand")({
  component: BrandReviewPage,
});
